import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ampli } from '../../../../ampli';
import { ownTractorPageInfo, sellTractorPageInfo } from '../../../../constants/pageInfo/pageInfo.constant';
import { ANONYMOUS_USER_ID, TEMP_DATA_KEYS } from '../../../../constants/tempData/tempData.contant';
import { usePostInquiryTractorMutation } from '../../../../hooks/api/inquiry/mutations/usePostInquiryTractor.mutation';
import { usePatchUserFlarelaneTagsMutation } from '../../../../hooks/api/user/mutations/usePatchUserFlarelaneTags.mutation';
import { useGetUsersMeQuery } from '../../../../hooks/api/user/queries/useGetUsersMe.query';
import { useRedirectToStoredPage } from '../../../../hooks/page/useRedirectToStoredPage';
import { useAppDispatch } from '../../../../hooks/store/useStore';
import { useUserTempData } from '../../../../hooks/userTempData/useUserTempData';
import { IUserOwnTractorTempData, IUserSellTractorTempData } from '../../../../interfaces/Element.interfaces';
import { userOwnTractorSurveySlice } from '../../../../store/userOwnTractorSurveySlice';
import { userSellTractorSurveySlice } from '../../../../store/userSellTractorSurveySlice';
import { browserStorage } from '../../../../utils/browserStorage.util';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';
import { LoadingPage } from '../../../etc/LoadingPage/LoadingPage';

export const AfterLoginPage = () => {
  const navigate = useNavigate();
  const hasExecuted = useRef(false);

  const getUsersMeQuery = useGetUsersMeQuery();

  const { mutate: patchUserFlarelaneTags } = usePatchUserFlarelaneTagsMutation();
  const { mutate: postUserInquiryTractor } = usePostInquiryTractorMutation();

  const { navigateToStoredPage } = useRedirectToStoredPage();

  const { getUserTempData, removeUserTempData, setUserTempData } = useUserTempData();

  const dispatch = useAppDispatch();
  const userSellTractorActions = userSellTractorSurveySlice.actions;
  const userOwnTractorActions = userOwnTractorSurveySlice.actions;

  useEffect(() => {
    if (!getUsersMeQuery.data?.id || hasExecuted.current) {
      return;
    }

    const { id: userId } = getUsersMeQuery.data;

    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'setUserId', messageParam: userId });
    }

    ampli.pvmLoginCompleted();

    setTimeout(() => {
      patchUserFlarelaneTags();
    }, 10000);

    if (sessionStorage.getItem('failedInquiryTractorId')) {
      const failedInquiryTractorId = sessionStorage.getItem('failedInquiryTractorId');
      postUserInquiryTractor({ reqBody: { productId: failedInquiryTractorId! } });
      sessionStorage.removeItem('failedInquiryTractorId');
    }

    if (
      browserStorage.getItem({ storageType: 'sessionStorage', itemKey: 'storedPageForRedirection' }) ===
      sellTractorPageInfo.requireImagePage.path
    ) {
      const { userTempData: anonymousUserTempData } = getUserTempData(ANONYMOUS_USER_ID);

      const anonymousSellTractorData: string | undefined = anonymousUserTempData.get(
        TEMP_DATA_KEYS.SELL_TRACTOR_SURVEY,
      );

      if (anonymousSellTractorData) {
        removeUserTempData({ userId: ANONYMOUS_USER_ID, dataKey: 'SELL_TRACTOR_SURVEY' });
        setUserTempData({ newTempData: anonymousUserTempData });

        const parsedSellTractorData: IUserSellTractorTempData = JSON.parse(anonymousSellTractorData);
        const { formData } = parsedSellTractorData;

        dispatch(userSellTractorActions.changeAllStates(formData));
      }
    }

    if (
      browserStorage.getItem({ storageType: 'sessionStorage', itemKey: 'storedPageForRedirection' }) ===
      ownTractorPageInfo.marketPricePage.path
    ) {
      const { userTempData: anonymousUserTempData } = getUserTempData(ANONYMOUS_USER_ID);

      const anonymousOwnTractorData: string | undefined = anonymousUserTempData.get(TEMP_DATA_KEYS.OWN_TRACTOR_SURVEY);

      if (anonymousOwnTractorData) {
        removeUserTempData({ userId: ANONYMOUS_USER_ID, dataKey: 'OWN_TRACTOR_SURVEY' });
        setUserTempData({ newTempData: anonymousUserTempData });

        const parsedOwnTractorData: IUserOwnTractorTempData = JSON.parse(anonymousOwnTractorData);
        const { formData } = parsedOwnTractorData;

        dispatch(userOwnTractorActions.changeAllStates(formData));
      }
    }

    hasExecuted.current = true;

    // 회원가입 성공 시 => 회원가입 완료 페이지로 이동
    if (sessionStorage.getItem('join-complete') === 'true') {
      navigate('/join-complete', { replace: true });
    } else {
      // 전에 보던 페이지로 이동
      navigateToStoredPage();
    }
  }, [getUsersMeQuery.data, navigate, patchUserFlarelaneTags, navigateToStoredPage]);

  return <LoadingPage />;
};
